import { createStore } from 'vuex';

const modulesFiles = require.context('./modules', true, /\.js$/);

const modules = modulesFiles.keys().reduce((accumulator, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  const value = modulesFiles(modulePath);
  accumulator[moduleName] = value.default;
  return accumulator;
}, {});

const store = createStore({
  modules,
});

export default store;
